// 極東ゴム用の特別な関数
export default {
	setKneadAmount(th) {
		th.$nextTick(() => {
			let obj = []
			th.items.forEach((item) => {
				let date = th.$refs[`itemRecord-${item.id}`].$refs[`cell-0`][0].innerText
				let batch_amount = th.$refs[`itemRecord-${item.id}`].$refs[`cell-2`][0].innerText
				obj[date] = obj[date] != null ? obj[date] + Number(batch_amount) : Number(batch_amount)
			})
			th.items.forEach((item) => {
        let date = th.$refs[`itemRecord-${item.id}`].$refs[`cell-0`][0].innerText
        let text = ""
				if (obj[date] > 10) {
          text = "練りオーバー"
				} else if (obj[date] > 8) {
          text = "注意"
				} else {
          text = "OK"
				}
        th.$refs[`itemRecord-${item.id}`].$refs[`cell-7`][0].innerText = text
			})
		})
	},
}
